import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11999c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cache_operate" }
const _hoisted_2 = { class: "cache_operate_main" }
const _hoisted_3 = { class: "cache_operate_right" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mod_pagin" }
const _hoisted_7 = { class: "modal_wrap" }
const _hoisted_8 = { class: "modal_place_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 福卡名称： ")
], -1))
const _hoisted_10 = { class: "modal_place_input_content" }
const _hoisted_11 = { class: "modal_place_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 福卡图片： ")
], -1))
const _hoisted_13 = { class: "modal_place_input_content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal_place_input_hint" }, "上传说明：图片尺寸1：1比列，大小不能超过2M。", -1))
const _hoisted_15 = { class: "modal_place_input" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, "领取限制开关：", -1))
const _hoisted_17 = { class: "modal_place_input_content" }
const _hoisted_18 = { class: "modal_place_input" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, "领取限制数量：", -1))
const _hoisted_20 = { class: "modal_place_input_content" }

import { computed, createVNode, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Table, Pagination, Modal, message, Form, Tooltip, Radio, InputNumber } from 'ant-design-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import { FiveLuckyInfo, LuckyCardColumn, LuckyCardForm } from '@/types/application/FiveLuckyGame';
import { RootModal } from '@/components/CDelModal.vue';
import CUpload from '@/components/CUpload.vue';
import fiveLuckyApi from '@/api/application/fiveLuckyGame';
import { ExclamationCircleFilled, CheckCircleTwoTone, ExclamationCircleTwoTone } from '@ant-design/icons-vue/lib/icons';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const aTable = Table;
const aTooltip = Tooltip;
const aModal = Modal;
const aPagination = Pagination;
const useForm = Form.useForm;
const aFormItem = Form.Item;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aInputNumber = InputNumber;
const route = useRoute();
const router = useRouter();

const showLoading = ref(false);
// 选择
const selectedRowKeys = ref<Key[]>([]);
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const isDisabled = computed(() => (selectedRowKeys.value.length === 0 ? true : false));
// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 1, // 总页数
  options: ['10', '20', '30', '40', '50'], // 选项
});

const columns = [
  {
    title: '活动名称',
    dataIndex: 'title',
    key: 'title',
    align: 'center',
  },
  {
    title: '福卡图片',
    dataIndex: 'pic',
    key: 'pic',
    align: 'center',
    width: 100,
    slots: { customRender: 'pic' },
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    align: 'center',
  },
  {
    title: '限制数量',
    dataIndex: 'limit_count',
    key: 'limit_count',
    align: 'center',
  },
  {
    title: '是否限制',
    dataIndex: 'limit_switch',
    key: 'limit_switch',
    align: 'center',
    slots: { customRender: 'limit_switch' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    align: 'center',
    slots: { customRender: 'operation' },
  },
];
const list = ref<LuckyCardColumn[]>([]);
const parentInfo = ref<FiveLuckyInfo>({
  id: 0,
  title: '',
  intro: '',
  studio_id: 0,
  status: 0,
  open: 0,
  max: 0,
  duration: 0,
  num: 0,
});
const getParentInfo = () => {
  if (!route.query?.id) {
    message.error('无效的链接地址，请重试！');
    setTimeout(() => {
      router.push({ name: 'FiveLuckyGame' });
    }, 2000);
  }
  return new Promise((resolve, reject) => {
    fiveLuckyApi
      .getfiveBlessingView({
        params: {
          id: route.query?.id,
        },
      })
      .then((res) => {
        parentInfo.value = res.data.data;
        resolve({});
      })
      .catch((err) => {
        message.error(err.data.error);
        reject({ err });
      });
  });
};

const getLuckyCardList = () => {
  showLoading.value = true;
  const search = {
    pid: parentInfo.value.id,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  fiveLuckyApi
    .getLuckyCardList({ params: search })
    .then((res) => {
      if (res.data.data?.data) {
        list.value = res.data.data.data;
        pageConfig.current = res.data.data.current_page;
        pageConfig.totalSize = res.data.data.total;
      } else {
        list.value = [];
        pageConfig.current = 1;
        pageConfig.totalSize = 1;
      }
    })
    .catch((err) => {
      message.error(err.data.error);
    })
    .finally(() => {
      showLoading.value = false;
    });
};

const init = async () => {
  if (!parentInfo.value.id) {
    await getParentInfo();
  }
  getLuckyCardList();
};

init();

/**
 * 弹出福卡
 */
const popupLuckyCard = (item: LuckyCardColumn) => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: `确认弹出福卡？`,
    onOk() {
      return new Promise((resolve) => {
        fiveLuckyApi
          .popupLuckyCard({
            id: item.id,
          })
          .then((res) => {
            message.success('操作成功！');
            resolve({});
          })
          .catch((err: any) => {
            message.warn(err.data.error);
            resolve(err);
          });
      });
    },
  });
};

/**
 * 删除福卡
 */
const delCard = (item?: LuckyCardColumn) => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: `确认删除该项？`,
    onOk() {
      return new Promise((resolve) => {
        fiveLuckyApi
          .delLuckyCard({
            ids: item?.id || selectedRowKeys.value,
          })
          .then(() => {
            message.success('操作成功！');
            selectedRowKeys.value = [];
            getLuckyCardList();
            resolve({});
          })
          .catch((err: any) => {
            message.warn(err.data.error);
            resolve(err);
          });
      });
    },
  });
};

const createModal = reactive<RootModal>({
  title: '添加福卡',
  visible: false,
  loading: false,
});

const formData = ref<LuckyCardForm>({
  title: '',
  pic: '',
  intro: '',
  limit_switch: 1,
  limit_count: 1,
});

watch(
  () => formData.value.limit_switch,
  (nal) => {
    if (nal === 1) {
      formData.value.limit_count = formData.value.limit_count || 1;
    }
  }
);

const rulesRef = reactive({
  title: [
    {
      required: true,
      message: '请输入福卡名称',
    },
  ],
  pic: [
    {
      required: true,
      message: '请上传图片',
    },
  ],
});
const { resetFields, validate, validateInfos } = useForm(formData, rulesRef);

const resetCreateModal = () => {
  resetFields();
  createModal.visible = false;
  createModal.loading = false;
  createModal.title = '添加福卡';
  formData.value.id = 0;
};
const openCreateModal = (item?: LuckyCardColumn) => {
  if (item) {
    createModal.title = '编辑福卡';
    formData.value = {
      id: item.id,
      title: item.title,
      pic: item.pic,
      intro: item.intro,
      limit_switch: item.limit_switch,
      limit_count: item.limit_count,
    } as LuckyCardForm;
  }
  createModal.visible = true;
};

const apifunc = computed(() => (formData.value.id ? 'editLuckyCard' : 'addLuckyCard'));
const fetching = ref(false);
const submitCard = () => {
  validate()
    .then(() => {
      fetching.value = true;
      fiveLuckyApi[apifunc.value]({
        pid: parentInfo.value.id,
        studio_id: parentInfo.value.studio_id,
        ...formData.value,
      })
        .then(() => {
          message.success('操作成功！');
          resetCreateModal();
          getLuckyCardList();
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          fetching.value = false;
        });
    })
    .catch((err) => {
      console.log('error', err);
    });
};

// upload module
function getBase64(img: Blob, callback: (base64Url: string) => void) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
}
const fileList = ref([]);
const loading = ref<boolean>(false);
const handleChange = (info: FileInfo): void => {
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  }
  if (info.file.status === 'done') {
    getBase64(info.file.originFileObj, () => {
      if (info.file?.response?.code === 200) {
        formData.value.pic = info.file?.response?.data.url;
      } else {
        message.error(info.file?.response?.message);
      }
      loading.value = false;
    });
  }
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = () => {
  formData.value.pic = '';
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openCreateModal()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加福卡")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          class: "mod_btn",
          type: "link",
          danger: "",
          disabled: _unref(isDisabled),
          onClick: delCard
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_btn_icon",
              "icon-class": "del"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 删除 ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(aTable), {
        loading: showLoading.value,
        "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
        columns: columns,
        "data-source": list.value,
        pagination: false,
        class: "liveList_w",
        "row-key": "id"
      }, {
        pic: _withCtx(({ record }) => [
          _createElementVNode("img", {
            class: "card_img",
            src: record.pic,
            alt: ""
          }, null, 8, _hoisted_5)
        ]),
        limit_switch: _withCtx(({ record }) => [
          _createVNode(_unref(CheckCircleTwoTone), {
            twoToneColor: record.limit_switch ? '#52c41a' : '#c0c4cc',
            class: "icon"
          }, null, 8, ["twoToneColor"])
        ]),
        operation: _withCtx(({ record }) => [
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(" 弹出 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (popupLuckyCard(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "luckycard_popup" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(" 编辑 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (openCreateModal(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "luckycard_edit" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(" 删除 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (delCard(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "luckycard_del" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["loading", "row-selection", "data-source"]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(aPagination), {
          "show-quick-jumper": "",
          total: pageConfig.totalSize,
          current: pageConfig.current,
          "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig.current) = $event)),
          "page-size": pageConfig.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.pageSize) = $event)),
          pageSizeOptions: pageConfig.options,
          "show-less-items": "",
          "show-size-changer": "",
          onChange: getLuckyCardList,
          onShowSizeChange: getLuckyCardList
        }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
      ], 512), [
        [_vShow, pageConfig.totalSize > pageConfig.pageSize]
      ])
    ]),
    _createVNode(_unref(aModal), {
      visible: createModal.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((createModal.visible) = $event)),
      title: createModal.title,
      onOk: _cache[7] || (_cache[7] = ($event: any) => (openCreateModal())),
      onCancel: resetCreateModal,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: resetCreateModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          loading: createModal.loading,
          onClick: submitCard
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).title)), {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: formData.value.title,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.title) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 16)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).pic)), {
                default: _withCtx(() => [
                  _createVNode(CUpload, {
                    "file-list": fileList.value,
                    "handle-change": (info) => handleChange(info),
                    loading: loading.value,
                    "image-name": formData.value.pic,
                    "click-stop": imageDel,
                    class: "ant_upload"
                  }, null, 8, ["file-list", "handle-change", "loading", "image-name"])
                ]),
                _: 1
              }, 16)
            ])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(aRadioGroup), {
                value: formData.value.limit_switch,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.limit_switch) = $event)),
                style: {"line-height":"32px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("开启")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("关闭")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(aInputNumber), {
                value: formData.value.limit_count,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.limit_count) = $event)),
                min: 1
              }, null, 8, ["value"])
            ])
          ], 512), [
            [_vShow, formData.value.limit_switch]
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})